import { render, staticRenderFns } from "./BlogModeForm.vue?vue&type=template&id=33aaa064&scoped=true&"
import script from "./BlogModeForm.vue?vue&type=script&lang=ts&"
export * from "./BlogModeForm.vue?vue&type=script&lang=ts&"
import style0 from "./BlogModeForm.vue?vue&type=style&index=0&id=33aaa064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aaa064",
  null
  
)

export default component.exports